// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-title[data-v-01ffe3b1]{padding:10px 0}.sub-title .text[data-v-01ffe3b1]{font-size:16px;font-weight:500;padding:10px 0}.sub-title .desc[data-v-01ffe3b1]{background:#fff;padding:10px;border-radius:8px}\n", ""]);
// Exports
module.exports = exports;
